/**
 * @description 库存管理
 */
import request from "@/utils/request";

// 分页查询
export function queryTable(params) {
  return request({
    url: "/inventory/selectPageV164",
    method: "get",
    params,
  });
}
// 分页查询
export function queryTableNew(params) {
  return request({
    url: "/inventoryDetail/selectPageV164",
    method: "get",
    params,
  });
}

// 库存预警设置
export function warningSetting(data) {
  return request({
    url: "/inventory/updateLimit",
    method: "post",
    data,
  });
}

// 出库查询
export function queryStorageTable(data) {
  return request({
    url: "/inventory/outBoundQuery",
    method: "post",
    data,
  });
}

// 查询详情
export function queryInventoryById(id) {
  return request({
    url: `/inventory/getDetailInfoByIdV164/${id}`,
    method: "get",
  });
}
